import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import EffectiveDate from './EffectiveDate';
import MemberInfo from '../member-info/MemberInfo';
//import EditMemberInfo from '../member-info/EditMemberInfo';
import DependentInfo from '../dependent-info/DependentInfo';
import AddDependentInfo from '../dependent-info/AddDependentInfo';
import ProductSelection from '../product-selection/ProductSelection';
import ComparePlanResultPage from '../product-selection/ComparePlanResultPage';
import ComparePlanResultPageMobile from '../product-selection/ComparePlanResultPageMobile';
import UploadDocument from '../upload-document/UploadDocument';
import ReviewAndConfirm from '../review-and-confirm/ReviewAndConfirm';
import NavigationSteps from './NavigationSteps';
import LifeChangeEventHeader from '../Header/header';
//import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './enrollmentcoverageflow.scss';

const EnrollmentCoverageFlow = () => {
  const location = useLocation();
  /*const { employeeInfo, dependentsInfo } = useSelector(
    (state) => state.memberSummary,
  );*/
  const {
    selectedEnrollmentFlow,
    showEffectiveDate,
    employerApproval,
    insurerApproval,
  } = location.state;
  console.log(
    'selectedEnrollmentFlow ::::::::::: ',
    selectedEnrollmentFlow,
    showEffectiveDate,
  );

  const getEffectiveDateContent = () => {
    if (
      ['AddDependent', 'DeleteDependent', 'AddressChange'].includes(
        selectedEnrollmentFlow,
      )
    ) {
      return {
        Title: 'Effective Date',
        Greetings: '',
        Label: 'Effective Date',
      };
    }
    return {};
  };

  const getNavSteps = () => {
    let navSteps = [];
    if (selectedEnrollmentFlow === 'AddDependent') {
      navSteps = [
        'Member Profile',
        'Dependent Information',
        'Product Selection',
        'Review And Confirm',
      ];
    }
    if (selectedEnrollmentFlow === 'DeleteDependent') {
      navSteps = ['Dependent Information', 'Review And Confirm'];
    }
    if (selectedEnrollmentFlow === 'AddressChange') {
      navSteps = [
        'Member Profile',
        'Dependent Information',
        'Review And Confirm',
      ];
    }
    if (showEffectiveDate) {
      navSteps.unshift('Effective Date');
    }
    return navSteps;
  };
  const enrollmentFlowWiseStepsConf = {
    AddDependent: {
      navStepsName: getNavSteps(),
    },
    DeleteDependent: {
      navStepsName: getNavSteps(),
    },
    AddressChange: {
      navStepsName: getNavSteps(),
    },
  };
  const navStepsName = selectedEnrollmentFlow
    ? enrollmentFlowWiseStepsConf[selectedEnrollmentFlow].navStepsName
    : [];

  /*console.log(
    'dependentsInfo employeeInfo ::::: >>> ::::  ',
    dependentsInfo,
    employeeInfo,
  );
  const dependentsInfoData =
    dependentsInfo &&
    dependentsInfo?.length > 0 &&
    dependentsInfo.map((d) => {
      return {
        OID: d.OID,
        FirstName: d.FirstName,
      };
    });

  console.log('dependentsInfoData', dependentsInfoData); */
  const formFields = {
    selectedEnrollmentFlow: selectedEnrollmentFlow || '',
    adoptionOrBirthDate: '',
    //memberName: {
    //oid: employeeInfo.OID,
    //FirstName: employeeInfo.FirstName,
    //},
    //dependentsInfo: dependentsInfoData,
    dependentsInfo: false,
    dependentsInformation: [],
    updatedMemberInformation: null,
    newDependentInfoFields: [],
    isDependentInfoAvailable: false,
    newlyAddedDependent: [],
    approvalDetails: {
      insurerApproval: insurerApproval || false,
      employerApproval: employerApproval || false,
    },
    allNewlyAddedDependent: [],
    removedExistingDependent: [],
    memberAddressInfo: {},
    dependentAddressInfo: {},
    isMemberAddressUpdated: false,
    updatedDependentDetails: [],
    updatedCurrentDependentNumber: 0,
    activedependentSequenceNumber: 0,
    products: {
      selectedMedicalProduct: null,
      enrolledMedicalMember: [],
      selectedDentalProduct: null,
      enrolledDentalMember: [],
      selectedVisionProduct: null,
      enrolledVisionMember: [],
    },
    uploadedDocuments: [],
    updateMemberAddress: null,
  };

  const [enrollmentFormData, setEnrollmentFormData] = useState(formFields);

  const [currentStep, setCurrentStep] = useState(1);
  //const [addDepenedentInfoStep, setAddDepenedentInfoStep] = useState(false);
  const [currentStepKey, setCurrentStepKey] = useState(
    navStepsName ? navStepsName[0] : 'Effective Date',
  );
  const [showComparePlans, setShowComparePlans] = useState(false);
  const [compareProductsPlans, setCompareProductPlans] = useState(null);
  const [compareProductTabName, setCompareProductTabName] = useState('');

  const setSelectedCompareProducts = (products) => {
    setCompareProductPlans(products);
  };

  const nextStep = (skipOneSteps = false) => {
    if (skipOneSteps) {
      setCurrentStep(currentStep + 2);
      setCurrentStepKey(navStepsName[currentStep + 1]);
    } else {
      setCurrentStep(currentStep + 1);
      setCurrentStepKey(navStepsName[currentStep]);
    }
  };

  const prevStep = (skipOneSteps = false) => {
    if (skipOneSteps) {
      setCurrentStep(currentStep - 2);
      setCurrentStepKey(navStepsName[currentStep - 3]);
    } else {
      console.log('Current steps :::: ', currentStep);
      setCurrentStep(currentStep - 1);
      setCurrentStepKey(navStepsName[currentStep - 2]);
    }
  };

  const handleUpdateFromReview = (navName) => {
    const navStepsIndex = navStepsName.indexOf(navName);
    console.log('navStepsIndex >>>>>>>>>>>>>> ', navStepsIndex);
    if (navStepsIndex > 0) {
      setCurrentStep(navStepsIndex + 1);
      setCurrentStepKey(navStepsName[navStepsIndex]);
    }
  };

  console.log('currentStepKey ::::::::::::::: ', currentStepKey);

  const setCompareTabName = (tabName) => {
    console.log('setCompareTabName tabName', tabName);
    setCompareProductTabName(tabName);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <div className="enrollment-coverage-flow change-coverage-center">
      <LifeChangeEventHeader />
      {!showComparePlans ? (
        <div className="container-offset">
          <div>
            <Row className="grid-template ml-0 mr-0">
              <Col className="p-0">
                <div className="column-section-left">
                  {currentStepKey === 'Effective Date' && (
                    <EffectiveDate
                      nextStep={nextStep}
                      prevStep={prevStep}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                      contentData={getEffectiveDateContent()}
                      currentStep={currentStep}
                    />
                  )}
                  {currentStepKey === 'Member Profile' && (
                    <MemberInfo
                      nextStep={nextStep}
                      prevStep={prevStep}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                      currentStep={currentStep}
                    />
                  )}
                  {/*currentStepKey === 'Member Profile' &&
                  showEditMemberContactDetails && (
                    <EditMemberInfo
                      enrollmentFormData={enrollmentFormData}
                      nextStep={nextStep}
                      prevStep={prevStep}
                    />
                  )*/}
                  {currentStepKey === 'Dependent Information' && (
                    <DependentInfo
                      nextStep={nextStep}
                      prevStep={prevStep}
                      //addDepenedentInfoStep={addDepenedentInfoStep}
                      //setAddDepenedentInfoStep={setAddDepenedentInfoStep}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                    />
                  )}
                  {/*{currentStepKey === 'Add Dependent' && (
                  <AddDependentInfo
                    //nextStep={nextStep}
                    prevStep={prevStep}
                    //setAddDepenedentInfoStep={setAddDepenedentInfoStep}
                    //setCurrentStep={setCurrentStep}
                    enrollmentFormData={enrollmentFormData}
                    setEnrollmentFormData={setEnrollmentFormData}
                  />
                )} */}
                  {currentStepKey === 'Product Selection' && (
                    <ProductSelection
                      nextStep={nextStep}
                      prevStep={prevStep}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                      setShowComparePlans={setShowComparePlans}
                      setSelectedCompareProducts={setSelectedCompareProducts}
                      setCompareTabName={setCompareTabName}
                    />
                  )}
                  {currentStepKey === 'Upload Documents' && (
                    <UploadDocument
                      nextStep={nextStep}
                      prevStep={prevStep}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                    />
                  )}
                  {currentStepKey === 'Review And Confirm' && (
                    <ReviewAndConfirm
                      nextStep={nextStep}
                      prevStep={prevStep}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                      handleUpdateFromReview={handleUpdateFromReview}
                    />
                  )}
                </div>
              </Col>
              <Col className="p-0">
                <div className="column-section-right">
                  {navStepsName &&
                    navStepsName.map((f, index) => (
                      <NavigationSteps
                        navigationStepName={f}
                        //onClickHandler={f.onClickHandler}
                        key={index}
                        keyIndex={index + 1}
                        currectStep={currentStep}
                        enrollmentFormData={enrollmentFormData}
                        currentStepKey={currentStepKey}
                      />
                    ))}
                </div>
              </Col>
            </Row>
          </div>
          <ToastContainer
            draggable
            pauseOnHover
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            autoClose={5000}
            position="top-center"
            newestOnTop={false}
            hideProgressBar={false}
            className="toast-wrapper"
          />
        </div>
      ) : (
        <>
          <div className="desktop">
            <ComparePlanResultPage
              setShowComparePlans={setShowComparePlans}
              compareProductsPlans={compareProductsPlans}
              compareProductTabName={compareProductTabName}
            />
          </div>
          <div className="mobile">
            <ComparePlanResultPageMobile
              setShowComparePlans={setShowComparePlans}
              compareProductsPlans={compareProductsPlans}
              compareProductTabName={compareProductTabName}
            />
          </div>
        </>
      )}
    </div>
  );
  //}
};

export default EnrollmentCoverageFlow;
